import { urls } from './';

const videos = {
    visao_mp4: urls.assets + 'videos/visao.mp4',
    missao_mp4: urls.assets + 'videos/missao.mp4',
    valores_mp4: urls.assets + 'videos/valores.mp4'
};

export { videos };